import { EPostStatus } from '@constants';
import { useQuery } from '@tanstack/react-query';

import { sdk } from '@/services';

type PostsCounts = Record<string, number>;

const PostService = sdk.getService('PostService');

export const usePostsCounts = () => {
  const {
    data = {},
    isLoading,
    refetch
  } = useQuery<PostsCounts>({
    queryKey: ['posts', 'counts'],
    queryFn: () => PostService.getPostsCounts(),
    refetchOnWindowFocus: false,
    retry: false
  });

  const counts = data ?? {};

  const drafts = counts[EPostStatus.DRAFT] ?? 0;
  const scheduled = counts[EPostStatus.SCHEDULED] ?? 0;

  return {
    counts,
    drafts,
    scheduled,
    isLoading,
    refetch
  };
};
